import React from 'react'
import {connect} from 'react-redux'
import selecionarRota from '../../actions/rota/selecionarRota';
import {DetalhesRotaItinerario} from './DetalhesRotaItinerario';
import selecionarItinerario from '../../actions/itinerario/selecionarItinerarios'

export class RotasItinerario extends React.Component {

    render() {
        return (
            <React.Fragment>
                <div className="geral">
                    <div className="resumo">
                        <div className="row">
                            <div title='Conexões' className="col-lg-1 col-xl-1"
                                 onClick={() => this.props.alterarExibicao(this.props.rota)}
                                 style={{cursor: 'pointer'}}>
                                {this.props.rota.exibirDetalhe ?
                                    <i className="material-icons" style={{cursor: 'pointer'}}>
                                        &#xe5c7;
                                    </i> : <i className="material-icons" style={{cursor: 'pointer'}}>
                                        &#xe5c5;
                                    </i>}
                            </div>
                            <div className="col-lg-1 col-xl-1">
                                <span
                                    className="titulo-mobile">N° Rota&nbsp;</span>{this.props.rota.id}
                            </div>
                            <div className="col-lg-3 col-xl-3">
                                <span
                                    className="titulo-mobile">Nome Empresa:&nbsp;</span>{this.props.rota.nomeFantasiaEmpresa}
                            </div>
                            <div className="col-lg-3 col-xl-3">
                                <span
                                    className="titulo-mobile">Rota&nbsp;</span>{this.props.rota.descricao}
                            </div>
                            <div className="col-lg-2 col-xl-2">
                                <span
                                    className="titulo-mobile">Delimitação&nbsp;</span>{this.props.rota.delimitacao}
                            </div>
                        </div>
                    </div>
                    <div>
                        <DetalhesRotaItinerario rota={this.props.rota} selecionarItinerario={this.props.selecionarItinerario} selecionarRota={this.props.selecionarRota}/>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export const mapStateToProps = state => {
    return {
        empresaSelecionada: state.empresaSelecionada
    }};

export default connect(mapStateToProps, {
    selecionarRota,
    selecionarItinerario,
})(RotasItinerario)
